import { useTermsLogic } from "../../Components/TermsLogic/TermsLogic";
import React from 'react';
import { getBrandName } from "../../Components/getBrandName";
const TermCondition = () => {
  const { brandName} = getBrandName();
  const { sections, generateContent } = useTermsLogic();

  return (
    <div className="term-condition-page">
      <div className="term-condition-heading text-center">
        <h2 className="hero-heading text-white">Terms & Conditions</h2>
        <p className="text-muted" style={{fontSize:"1.5rem"}}>Effective Date: <strong>July 3, 2025</strong></p>
      </div>

      <div className="privacy-container py-5">
        <div className="row">
          <div className="col-12">
        <p className='text-muted'>
          Welcome to {brandName} – your trusted partner in e-commerce insights. These Terms & Conditions ("Terms") govern your access to and use of the {brandName} website, services, tools, and platform, whether as a visitor, registered user, or subscriber.
          <br/ >By accessing or using any part of our platform or services, you agree to comply with and be legally bound by these Terms. If you do not agree with any part of these Terms, do not use our services.
        </p>
            {sections.map((section) => (
              <div key={section.id} className="mb-5">
                <h5 className="privacy-title">{section.title}</h5>
                <div className="text-muted">
                  {generateContent(section.id)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermCondition;
